

















import { computed, defineComponent, PropType, watch } from '@nuxtjs/composition-api'
import ggoLogger from '@/modules/ggo-logger'
import { LogName } from '@/interfaces/Logger'

const icons = {
  'sad-magnifier': require('@/assets/img/icon/sad-magnifier.svg'),
  'no-location': require('@/assets/img/icon/no-location.svg'),
  'no-date': require('@/assets/img/icon/no-date.svg'),
  'system-error': require('@/assets/img/icon/system-error.svg'),
  disconnect: require('@/assets/img/icon/disconnect.svg'),
} as const

export type Icon = keyof typeof icons

export default defineComponent({
  props: {
    icon: {
      type: String as PropType<Icon>,
      default: () => icons['sad-magnifier'],
      validator: (value: Icon) => Object.keys(icons).includes(value as Icon),
    },
    message: {
      type: String,
      default: '',
    },
  },
  setup (props) {
    const iconStyle = computed(() => ({
      backgroundImage: `url(${icons[props.icon]})`,
    }))

    watch(() => props.message, () => {
      ggoLogger.info(LogName.TOAST, { type: 'danger', message: props.message })
    }, { immediate: true })

    return {
      iconStyle,
    }
  },
})
